export interface Industry {
  id: number;
  industryName: string;
  industryImage: string;
  industryDetail: string;
  url?: string;
}

export const industriesData: Industry[] = [
  {
    id: 1,
    industryName: 'industries.industry.retail',
    industryImage: 'High-street.png',
    industryDetail: 'industries.retail.industryDetail',
    url: 'industries/retail',
  },
  {
    id: 2,
    industryName: 'industries.industry.malls',
    industryImage: 'Shopping-malls.png',
    industryDetail: 'industries.malls.industryDetail',
    url: 'industries/malls',
  },
  {
    id: 3,
    industryName: 'industries.industry.telecom_banking',
    industryImage: 'Telco-retail.png',
    industryDetail: 'industries.telecom_banking.industryDetail',
    url: 'industries/telecom-banking',
  },
  {
    id: 4,
    industryName: 'industries.industry.forecourt',
    industryImage: 'Forecourt.png',
    industryDetail: 'industries.forecourt.industryDetail',
    url: 'industries/forecourt',
  },
];
